import React from "react";
import { YOUTUBE_CHANNEL_URL } from "constants/social";
import styles from "./socialLinks.module.scss";

const SOCIALS = [
    { type: "whatsapp", url: "https://wa.me/+375447772749" },
    { type: "telegram", url: "https://t.me/blagoproby" },
    { type: "viber", url: "viber://chat?number=+375447772749" },
    { type: "tiktok", url: "https://tiktok.com/@blagoproby" },
    { type: "youtube", url: YOUTUBE_CHANNEL_URL },
    { type: "instagram", url: "https://instagram.com/blago_pro" },
];

const SocialLinks = () => {
    return (
        <div className={styles.root}>
            {SOCIALS.map((social) => (
                <a
                    key={social.type}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`${styles.icon} ${styles[social.type]}`}
                    title={social.type}
                >
                    <span className={styles.srOnly}>{social.type}</span>
                </a>
            ))}
        </div>
    );
};

export default SocialLinks;